import { FC } from 'react';
import './style.scss';

export interface ILoaderBlueProps {
}

export const LoaderBlue: FC<ILoaderBlueProps> = () => {
  return (
    <div className="blue-loader">
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
      <span className="dot"/>
    </div>
  );
};
